import { ChooseLanguageButton, ChooseLanguageLink } from '../view/choose-language'
import { PageMetadata } from '../view/page-metadata'
import { CHOOSE_LANGUAGE_PAGETITLE } from '../messages'
import { useSearchParams } from 'react-router-dom'
import { DelayedBlock } from '../controls/delayed-block/delayed-block'

export const ChooseLanguagePage = () => {

    const [ searchParams ] = useSearchParams();

    return <>
        <PageMetadata pageTitle={CHOOSE_LANGUAGE_PAGETITLE}/>
        <ChooseLanguageLink searchParams={searchParams}/>
    </>
}

export const ChooseLanguageEmbeededPage = ({ onLanguageSelected, disabled }: {
    onLanguageSelected: (lang:string) => void
    disabled?: boolean
}) => {

    return <>
        <PageMetadata pageTitle={CHOOSE_LANGUAGE_PAGETITLE}/>
        <DelayedBlock>
            <ChooseLanguageButton onLanguageSelected={ onLanguageSelected } disabled={disabled}/>
        </DelayedBlock>
    </>

}